import { CUSTOMER_DATA, SEND_EVENT } from '@/js/analytics/const'

export default async function sendCustomerData(data) {
  // Send data to analytics server
  console.log(data);
  if ('undefined' === typeof window.eS) return false
  console.log('Sending customer data:', data);
  // eslint-disable-next-line no-undef
  return eS(SEND_EVENT, CUSTOMER_DATA, {
    [CUSTOMER_DATA]: {
      ...data,
    },
  })
}
